export enum Education {
  NoHighSchoolDiploma = 'NoHighSchoolDiploma',
  HighSchoolDiploma = 'HighSchoolDiploma',
  SomeCollegeNoDegree = 'SomeCollegeNoDegree',
  VocationalTechnicalDegree = 'VocationalTechnicalDegree',
  AssociatesDegree = 'AssociatesDegree',
  Bachelors = 'Bachelors',
  Masters = 'Masters',
  Phd = 'Phd',
  MedicalDegree = 'MedicalDegree',
  LawDegree = 'LawDegree',
}

export const EducationOptions = [
  { label: 'Some High School', value: Education.NoHighSchoolDiploma },
  { label: 'High School', value: Education.HighSchoolDiploma },
  { label: 'Some College', value: Education.SomeCollegeNoDegree },
  { label: '2 year College', value: Education.AssociatesDegree },
  { label: '4 year College', value: Education.Bachelors },
  { label: 'Graduate Degree', value: Education.Masters },
  { label: 'Doctorate', value: Education.Phd },
];

export const GEICO_CA_DECLINE_ANSWER_EDUCATION = {
  label: 'I decline to provide',
  value: null,
};
